import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useTelegram } from './hooks/useTelegram'
import Header from './components/Header'
import BottomNav from './components/BottomNav'
import Home from './pages/Home'
import Messages from './pages/Messages'
import Profile from './pages/Profile'
import Game from './pages/Game'
import Music from './pages/Music'

function App() {
  const { ready } = useTelegram()

  useEffect(() => {
    ready()
  }, [ready])

  return (
    <Router>
      <div className="min-h-screen bg-telegram-bg text-telegram-text flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto pb-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/game" element={<Game />} />
            <Route path="/music" element={<Music />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <BottomNav />
      </div>
    </Router>
  )
}

export default App
